import '../css/style-lgp-portal.scss';
import Modernizr from 'modernizr';
import mediaQuery from '@util/media-queries';
import OrderItemPendingController from '@modules/orders/orderItemPendingController';
import OrderItemController from '@modules/orders/orderItemController';
import {toggleAnimationFor} from '@util/EventUtils';
import {transEndEventName} from '@util/animation-prefixes';
import {Corpus, jqueryDropDownMenu} from '@modules/lazy-imports';

// update "Pending order" label
$( document ).on( 'orderitempending:change', function ( e, data ) {
    var label = $( '#orders-pending-label' );
    label.attr( 'data-item-count', parseInt( label.attr( 'data-item-count' ), 10 ) - data.count );
} );
$( document ).on( 'orderitemapproved:change', function ( e, data ) {
    var label = $( '#orders-approved-label' );
    label.attr( 'data-item-count', parseInt( label.attr( 'data-item-count' ), 10 ) + data.count );
} );
$( document ).on( 'orderitempending:change', function ( e, data ) {
    $( '.adm-pending-orders' ).toggleClass( 'is-empty', !$( '.odr-list .accordion-item' ).length );
} );

/**
 * Initialize DOM for Page
 */
var Page = (function () {

    /** helpers **/
    function toggleRegionActions ( e ) {
        var $container = $( e.target ).parents( '.rgn-list' ),
            checkboxList = $container.find( ':checkbox' ),
            allUnchecked = true;

        checkboxList.each( function ( i, item ) {
            if ( item.checked ) {
                allUnchecked = false;
            }
        } );

        $container.find( '.actions [data-item-action-list]' ).toggleClass( 'hidden', allUnchecked );
    }

    function loadOrderDataFor ( orderItems ) {
        // init OrderItems

        orderItems.each( function () {
            var orderStatus = this.getAttribute( 'data-order-status' ),
                orderItem = this;

            switch ( orderStatus ) {
                case 'pending':
                    new OrderItemPendingController( orderItem );
                    break;

                case 'approved':
                default:
                    // All other order status: processing, shipped, delivered...
                    new OrderItemController( orderItem );

            }
        } );
    }

    return {

        nodes: {},

        onDOMContentLoaded: function () {
            // noop
        },

        init: function () {
            // all LGP page will be treated as anon
            var self = this;

            this.nodes.$page = $( '#s4-workspace' );
            this.nodes.$form = $( '#aspnetForm' );
            this.nodes.$siteContent = $( '#page-content' );
            this.nodes.$mainContent = $( '#body-content' );
            this.nodes.$headerWrapper = $( '#header-outer' );
            this.nodes.$header = $( '#header' );
            this.nodes.$topNavCont = $( '#header-outer' );
            this.nodes.$leftNav = $( '#navigationBeta' );
            this.nodes.$officeMenu = $( '#office-menu' );
            this.nodes.$officeMenuLists = $( '#office-menu-lists' );
            this.nodes.$notifyBadge =
                $( '<div class="notify-badge odr-item-badge"><i class="icon-notebook odr-item-icon"><i class="icon-ok"></i></i></div>' );

            var nodes = this.nodes;

            this.initAdminPortal();
            this.initOrderItems();
            $( document ).ready( this.onDOMContentLoaded.bind( this ) );

            // refactor toggle resource tabs
            function hideResourceTab () {
                $( '.rsrc-tab' ).removeClass( 'js-active' );
            }

            $( '.rsrc-tab' ).on( 'click', function ( e ) {
                $( e.currentTarget ).addClass( 'js-active' );
            } ).on( 'mouseover', function ( e ) {
                var $target = $( e.currentTarget );
                window.clearTimeout( $target.data( 'hideTimeout' ) );
                $target.data( 'hideTimeout', null );
            } ).on( 'mouseout', function ( e ) {
                var hideId = window.setTimeout( hideResourceTab, 250 );
                $( e.currentTarget ).data( 'hideTimeout', hideId );
            } );

            // init auto-scroll for header links
            var $headerWrapper = nodes.$headerWrapper;
            // bind auto-scrollers
            $headerWrapper.find( '.product-families a' ).on( 'click', function ( e ) {
                var targetHref = this.href.split( '#' )[1];

                // ignore title-level links for mobile menus
                if ( Modernizr.mq( mediaQuery.max.screenMedium ) && /^section-/.test( targetHref ) ) {
                    return;
                }

                var $target = $( '#' + targetHref );
                // only attach to <a href="#target">
                if ( !this.href || !$target[0] ) {
                    return;
                }
                e.preventDefault();
                $target.scrollToElement();
            } );

            // initialize modules
            Corpus().then( () => {
                nodes.$siteContent.corpus( 'tabs', {
                    controls: '.tabNavigation',
                    panel: '.tabPanel',
                    active_class: 'current',
                    effect: 'slider'
                } );
            } );

            // toggle reveal items
            this.nodes.$siteContent.on( 'click', 'a[data-reveal-target]', function ( e ) {
                e.preventDefault();
                var target = $( e.target.hash );
                if ( target[0] ) {
                    target.addClass( 'revealed' );
                    e.target.parentNode.removeChild( e.target );
                }

            } );

            // dropdown select menus
            jqueryDropDownMenu().then( () => {
                nodes.$page.find( '.dropDownSelect' ).dropDownSelect();
            } );

        },

        initOrderItems: function () {
            var orderItems = $( '[data-order-status]' );
            loadOrderDataFor( orderItems );
        },

        initAdminPortal: function () {
            var nodes = this.nodes;

            // handle rgn-list item select
            $( '.rgn-list' ).on( 'change', 'input[type="checkbox"]', toggleRegionActions );

            this.nodes.$mainContent.append( this.nodes.$notifyBadge );

            $( document )
                .on( 'orderitem:closed', () => toggleAnimationFor( this.nodes.$notifyBadge[0], 'puff' ) );

            // toggle lft slide out menu
            var toggleOfficeMenu = function ( regionId ) {
                var target = $( '#' + regionId + '-office-list' );
                if ( target[0] ) {
                    closeOpenOfficeMenus();
                    target.addClass( 'on' );
                    nodes.$leftNav.addClass( 'js-menu-open' );
                }
                else {
                    closeOfficeMenu();
                }
            };
            var closeOpenOfficeMenus = function () {
                nodes.$officeMenu.find( 'li' ).removeClass( 'selected' );
                nodes.$officeMenuLists.find( '.submenu-item' ).each( function ( i, item ) {
                    $( item ).removeClass( 'on' );
                } );
            };
            var closeOfficeMenu = function () {
                if ( Modernizr.csstransitions ) {
                    nodes.$officeMenuLists.find( '.submenu-item.on' ).on( transEndEventName, function () {
                        nodes.$leftNav.removeClass( 'js-menu-open' );
                        $( this ).off();
                    } );
                    closeOpenOfficeMenus();
                }
                else {
                    closeOpenOfficeMenus();
                    nodes.$leftNav.removeClass( 'js-menu-open' );
                }
            };

            var $officeIndexList = $( '.office-list .indexList' );

            nodes.$officeMenuLists.on( 'click', '[data-menu-close]', closeOfficeMenu );
            nodes.$officeMenu.on( 'click', 'a', function ( e ) {
                e.preventDefault();
                var $target = $( this );
                var regionId = $target.attr( 'data-region' ).replace( ' ', '-' );
                toggleOfficeMenu( regionId );
                $target.parents( 'li' ).addClass( 'selected' );
            } );
        }

    };

}());

Page.init();
